import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import {twMerge} from "tailwind-merge";

const CustomButton = ({
  text,
  type = "button",
  onClick,
  classname = "",
  buttonClassName = "",
  iconClassName = "",
  width, // Default width
  height = "44px", // Default height
  iconDirection = "right", // Options: "right", "left", "up", "down"
  iconPosition = "after", // Options: "before", "after"
  ...props
}) => {
  const iconStyles = {
    transform:
      iconDirection === "right"
        ? "rotate(0deg)"
        : iconDirection === "left"
        ? "rotate(180deg)"
        : iconDirection === "up"
        ? "rotate(-90deg)"
        : "rotate(90deg)", // for "down"
  };

  return (
    <div className={`${classname}`}>
      <button
        onClick={onClick}
        className={twMerge(
          "flex items-center justify-center w-full rounded-[5px] font-roboto text-level-3 text-white font-semibold gap-[12px] px-[30px] py-[10px] transition-all duration-200",
          props.disabled ? "bg-slate-300" : "bg-blue-shades",
          buttonClassName
        )}
        style={{
          width: width,
          height: height,
        }}
        {...props}
      >
        {iconPosition === "before" && (
          <FaArrowRightLong style={iconStyles} className={twMerge("w-4 h-4 text-white", iconClassName)} />
        )}
        <span className="flex justify-center items-center">{text}</span>
        {iconPosition === "after" && (
          <FaArrowRightLong style={iconStyles} className={twMerge("w-4 h-4 text-white", iconClassName)} />
        )}
      </button>
    </div>
  );
};

export default CustomButton;
